import { IButtonStyles, ICommandBarItemProps } from "@fluentui/react";
// import { BsFilter} from 'react-icons/bs';
// import { BiFilter} from 'react-icons/bi';
// import { VscListFilter} from 'react-icons/vsc';
import { IoFilter } from "react-icons/io5";

import COLORES from "../theme/colores";

const _buttonStyles: IButtonStyles = {
  root: {
    borderRadius: 3,
    minWidth: 60,
  },
  label: { fontWeight: "semibold", fontSize: 12 },
};
const ICONFILTER = <IoFilter color={COLORES.Bases.primary}></IoFilter>;
const ICON_BS_FILTER: ICommandBarItemProps = {
  key: "filter",
  text: "Filtrar",
  iconProps: { iconName: "Breadcrumb" },
  buttonStyles: _buttonStyles,
  onRenderIcon() {
    return (
      <>
        <IoFilter color={COLORES.Bases.primary}></IoFilter>
      </>
    );
  },
};

const ICON_BS_FILTER_DISABLED: ICommandBarItemProps = {
  key: "filter",
  text: "Filtar",
  iconProps: { iconName: "Breadcrumb" },
  buttonStyles: _buttonStyles,
  disabled: true,
  onRenderIcon() {
    return (
      <>
        <IoFilter color={COLORES.Bases.Negro}></IoFilter>
      </>
    );
  },
};

const ICON_REPLY_LEFT: ICommandBarItemProps = {
  key: "AddTo",
  text: `Nuevo`,
  iconProps: { iconName: `ReplyAllMirrored` },
  buttonStyles: {
    root: { border: "solid 2px #f3f2f1", borderRadius: 3, minWidth: 100 },
    label: { fontWeight: "semibold", fontSize: 12 },
  },
};

const ICON_ADD: ICommandBarItemProps = {
  key: "AddTo",
  text: `Nuevo`,
  iconProps: { iconName: `add`, styles: { root: { color: "#fff" } } },
  buttonStyles: {
    root: {
      color: "#fff",
      background: "#0078d4",
      borderRadius: 3,
      minWidth: 100,
    },
    menuIcon: { color: "#fff" },
  },
};

const ICON_ADD_TABLE: ICommandBarItemProps = {
  key: "AddTo",
  text: `Nuevo`,
  iconProps: { iconName: `add` },
  buttonStyles: _buttonStyles,
};

const ICON_ADD_ICON: ICommandBarItemProps = {
  key: "AddTo",
  text: ``,
  iconProps: { iconName: `add`, styles: { root: { color: "#000" } } },
  buttonStyles: {
    root: {
      color: "#ffff",
      background: "#F3F2F1",
      borderRadius: 3,
      minWidth: 20,
    },
    menuIcon: { color: "#fff" },
  },
};
const ICON_BACK: ICommandBarItemProps = {
  key: "ReplyAll",
  text: "Atrás",
  iconProps: { iconName: "ReplyAll" },
  buttonStyles: _buttonStyles,
};

const ICON_BACK2: ICommandBarItemProps = {
  key: "Reply",
  text: "Atrás",
  iconProps: { iconName: "Reply" },
  buttonStyles: _buttonStyles,
};

const ICON_RELOAD: ICommandBarItemProps = {
  key: "SyncStatus",
  text: "Actualizar",
  iconProps: { iconName: "SyncStatus" },
  buttonStyles: _buttonStyles,
};

const ICON_CARGAMASIVA: ICommandBarItemProps = {
  key: "Upload",
  text: "Carga Masiva",
  iconProps: { iconName: "Upload" },
  buttonStyles: _buttonStyles,
};

const ICON_RELOAD2: ICommandBarItemProps = {
  key: "Refresh",
  text: "Actualizar",
  iconProps: { iconName: "Refresh" },
  buttonStyles: _buttonStyles,
};
const ICON_DOWNLOAD: ICommandBarItemProps = {
  key: "Download",
  text: "Descargar",
  iconProps: { iconName: "Download" },
  buttonStyles: _buttonStyles,
};

const ICON_DELETE: ICommandBarItemProps = {
  key: "Delete",
  text: "Eliminar",
  iconProps: { iconName: "Delete" },
  buttonStyles: _buttonStyles,
};

const ICON_FILTER: ICommandBarItemProps = {
  key: "filter",
  text: "Filtar",
  iconProps: { iconName: "Breadcrumb" },
  buttonStyles: _buttonStyles,
};
const ICON_EXCEL: ICommandBarItemProps = {
  key: "ExcelDocument",
  text: "Descargar",
  iconProps: { iconName: "ExcelDocument", style: { color: "green" } },
};
const ICON_GROUP_PEOPLE: ICommandBarItemProps = {
  key: "SyncStatus",
  text: "Eq. Evaluador",
  iconProps: { iconName: "Group" },
  buttonStyles: _buttonStyles,
};

const ICON_PDF: ICommandBarItemProps = {
  key: "ExcelDocument",
  text: "Descargar",
  iconProps: { iconName: "PDF", style: { color: "#4788C7" } },
};

const IconHelper = {
  ICONFILTER,
  ICON_REPLY_LEFT,
  ICON_ADD,
  ICON_BACK,
  ICON_BACK2,
  ICON_RELOAD,
  ICON_RELOAD2,
  ICON_FILTER,
  ICON_BS_FILTER,
  ICON_EXCEL,
  ICON_BS_FILTER_DISABLED,
  ICON_GROUP_PEOPLE,
  ICON_ADD_ICON,
  ICON_ADD_TABLE,
  ICON_PDF,
  ICON_DOWNLOAD,
  ICON_DELETE,
  ICON_CARGAMASIVA,
};

export default IconHelper;
